import { render, staticRenderFns } from "./DashboardAdoptionTrend.vue?vue&type=template&id=1a167986&scoped=true"
import script from "./DashboardAdoptionTrend.vue?vue&type=script&lang=js"
export * from "./DashboardAdoptionTrend.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdoptionTrend.vue?vue&type=style&index=0&id=1a167986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a167986",
  null
  
)

export default component.exports